// Importing required components and modules
import footerCss from "./Footer.module.css";

export default function Footer() {
  return (
    <div className={footerCss.topbarContainer}>
      <div className={footerCss.topbarLeft}>
        <img
          src="/assets/images/logo.png"
          alt="FACT LOGO"
          width="50"
          height="25"
          className={footerCss.logo}
        />
        <span className={footerCss.logoName}>
          Ⓒ The Fertilizers and Chemicals Travancore Limited (FACT)
        </span>
      </div>
      <div className={footerCss.topbarCenter}></div>
      <div className={footerCss.topbarRight}>
        <div className={footerCss.topbarLinks}></div>
        <div className={footerCss.topbarIcons}></div>
      </div>
    </div>
  );
}
